export const defaultResponse =
    '{"recommendations":[{"patient_id":0,"procedure_id":76,"specialty_id":153,"is_complete":false,"title":"Annual Physical","description":"It\'s recommended that adults get a blood pressure screening (according to the US Preventive Services Task Force), a flu vaccine (according to the CDC), and many more! Discuss with your doctor during an annual physical."},{"patient_id":0,"procedure_id":85,"specialty_id":101,"is_complete":false,"title":"Skin Screening","description":"The American Cancer Society recommends an annual skin screening for everyone 20 to 80 years of age."},{"patient_id":0,"procedure_id":11,"specialty_id":98,"is_complete":false,"title":"Dental Cleaning","description":"The American Dental Association recommends a routine dental cleaning for everyone 18 and up."},{"patient_id":0,"procedure_id":92,"specialty_id":386,"is_complete":false,"title":"Vision Exam","description":"An eye health exam is recommended every two years by the American Academy of Ophthalmology for adults from ages 20 to 80."},{"patient_id":0,"procedure_id":0,"specialty_id":0,"is_complete":true,"title":"Sign Up for Zocdoc","description":"Get started by creating a Zocdoc account. There\'s no easier way to get the preventive care you need!"}]}';
export const allCompletedResponse =
    '{"recommendations":[{"patient_id":0,"procedure_id":76,"specialty_id":153,"is_complete":true,"title":"Annual Physical","description":"It\'s recommended that adults get a blood pressure screening (according to the US Preventive Services Task Force), a flu vaccine (according to the CDC), and many more! Discuss with your doctor during an annual physical."},{"patient_id":0,"procedure_id":85,"specialty_id":101,"is_complete":true,"title":"Skin Screening","description":"The American Cancer Society recommends an annual skin screening for everyone 20 to 80 years of age."},{"patient_id":0,"procedure_id":11,"specialty_id":98,"is_complete":true,"title":"Dental Cleaning","description":"The American Dental Association recommends a routine dental cleaning for everyone 18 and up."},{"patient_id":0,"procedure_id":92,"specialty_id":386,"is_complete":true,"title":"Vision Exam","description":"An eye health exam is recommended every two years by the American Academy of Ophthalmology for adults from ages 20 to 80."},{"patient_id":0,"procedure_id":0,"specialty_id":0,"is_complete":true,"title":"Sign Up for Zocdoc","description":"Get started by creating a Zocdoc account. There\'s no easier way to get the preventive care you need!"}]}';

const defaultVisionDescription =
    'An eye health exam is recommended every two years by the American Academy of Ophthalmology for adults from ages 20 to 80.';
const defaultDentalDescription =
    'The American Dental Association recommends a routine dental cleaning for everyone 18 and up.';
const defaultSkinDescription =
    'The American Cancer Society recommends an annual skin screening for everyone 20 to 80 years of age.';
const defaultAnnualDescription =
    "It's recommended that adults get a blood pressure screening (according to the US Preventive Services Task Force), a flu vaccine (according to the CDC), and many more! Discuss with your doctor during an annual physical.";
const defaultSignUpDescription =
    "Get started by creating a Zocdoc account. There's no easier way to get the preventive care you need!";

const defaultVisionProcedure = '92';
const defaultDentalProcedure = '11';
const defaultSkinProcedure = '85';
const defaultAnnualProcedure = '76';
const defaultSignUpProcedure = '0';

const defaultVisionSpecialty = '386';
const defaultDentalSpecialty = '98';
const defaultSkinSpecialty = '101';
const defaultAnnualSpecialty = '153';
const defaultSignUpSpecialty = '0';

const defaultVisionTitle = 'Vision Exam';
const defaultDentalTitle = 'Dental Cleaning';
const defaultSkinTitle = 'Skin Screening';
const defaultAnnualTitle = 'Annual Physical';
const defaultSignUpTitle = 'Sign Up for Zocdoc';

export const recommendationDescriptions = {
    defaultVisionDescription,
    defaultDentalDescription,
    defaultSkinDescription,
    defaultAnnualDescription,
    defaultSignUpDescription,
};

export const recommendationProcedures = {
    defaultVisionProcedure,
    defaultDentalProcedure,
    defaultSkinProcedure,
    defaultAnnualProcedure,
    defaultSignUpProcedure,
};

export const recommendationSpecialties = {
    defaultVisionSpecialty,
    defaultDentalSpecialty,
    defaultSkinSpecialty,
    defaultAnnualSpecialty,
    defaultSignUpSpecialty,
};

export const recommendationTitles = {
    defaultVisionTitle,
    defaultDentalTitle,
    defaultSkinTitle,
    defaultAnnualTitle,
    defaultSignUpTitle,
};

export function recommendation(
    procedureId,
    specialtyId,
    title,
    description,
    isComplete
) {
    return {
        patient_id: 0,
        procedure_id: procedureId,
        specialty_id: specialtyId,
        is_complete: isComplete,
        title,
        description,
    };
}

export const unauthorizedResponse = [
    recommendation(
        defaultVisionProcedure,
        defaultVisionSpecialty,
        defaultVisionTitle,
        defaultVisionDescription,
        false
    ),
    recommendation(
        defaultDentalProcedure,
        defaultDentalSpecialty,
        defaultDentalTitle,
        defaultDentalDescription,
        false
    ),
    recommendation(
        defaultSkinProcedure,
        defaultSkinSpecialty,
        defaultSkinTitle,
        defaultSkinDescription,
        false
    ),
    recommendation(
        defaultAnnualProcedure,
        defaultAnnualSpecialty,
        defaultAnnualTitle,
        defaultAnnualDescription,
        false
    ),
    recommendation(
        defaultSignUpProcedure,
        defaultSignUpSpecialty,
        defaultSignUpTitle,
        defaultSignUpDescription,
        false
    ),
];
